<template>
	<div class="">
		<div class="content" ref="main"></div>
	</div>
</template>

<script>

	export default {
		name: "",
		components: {

		},
    props:{
      majorData:{type:Object,default:null}
    },
    watch:{
      majorData(vl){
        if(vl.pay!=null){
          this.getdata()

        }
      }
    },
		data() {
			return {
				main:null,
				option : {
					xAxis: {
						type: 'category',
						data: [],
						axisLine:{
							show:true,
							lineStyle:{
								color:"#29A7E1"
							}
						},
						axisLabel:{
							color:"#666666",
							hideOverlap:false,
							showMinLabel:true
						},
					},
					yAxis: {
						type: 'value',
						name:"薪资",
						nameTextStyle:{
							align:"right",
							color:"#333333",
						},
						axisLabel:{
							color:"#666666",
						},
						axisLine:{
							show:true,
							lineStyle:{
								color:"#29A7E1"
							}
						},
						splitLine:{
							show:true,
							lineStyle:{
								type:"dashed",
								color:"#666666",
								width:0.5,
							}
						}
					},
					series: [
						{
							data: [],
							type: 'bar',
							name:"Forest",
							showBackground: false,
              barWidth:70,
							itemStyle: {
								color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
										{ offset: 0, color: '#29A7E1' },
										{ offset: 1, color: '#29A7E1' }
									]),
								borderRadius: [5, 5, 0, 0]
							},
							label: {
								show: true,
								position: 'top',
								color:"#29A7E1",
                fontSize:'20px'
							},
						},
					]
				}
			}
		},
		mounted(){

		},
		methods: {
			getdata(){
        this.main = this.$echarts.init(this.$refs.main);
        this.option.xAxis.data= this.majorData.pay
        this.option.series[0].data= this.majorData.payrate
        this.main.setOption(this.option);
         window.onresize = () => {
        	this.main.resize();
        };
      }
		}


	}
</script>

<style scoped>
	.content{width: 100%;height: 421px;}
	@media (min-width: 768px) {
		.content{width: 100%;height: 421px;}
	}
	@media (min-width: 992px) {
		.content{width: 100%;height: 421px;}
	}

	@media (min-width: 1200px) {
		.content{width: 100%;height: 421px;}
	}

</style>



// WEBPACK FOOTER //
// src/views/tubiao/pay.vue